import loginFormTemplate from '../loginForm.html';

/* @ngInject */ export function OAuthAppRoutesProvider(AppRoutesProvider, Routes) {
  var resolve = {
    code: ($route) => $route.current.params.code,
    state: ($route) => $route.current.params.state
  };

  /*****************************************************************************
   * oauth */
  /**
   * @ngdoc      property
   * @name       oauth
   * @propertyOf app.object:AppRoutesProvider
   *
   * @description
   * The route definition object for the oauth route.
   *
   * This corresponds to the route: "/oauth/:registered?"
   *****************************************************************************/
  Object.assign(this, AppRoutesProvider, {
    oauth: {
      name: Routes.oauth,
      resolve: resolve,
      template: '<oauth state="$resolve.state" code="$resolve.code">'
    }
  });
}

/*******************************************************************************
 * oauth */
/**
 * @ngdoc    component
 * @module   app
 * @name     app.component:oauth
 *
 * @description
 * This component handles the authentication input as well as the start of the
 * forgot password.
 *******************************************************************************/
export const oAuthComponent = {
  template: loginFormTemplate,
  controller: Controller,
  bindings: { state: '<', code: '<' }
};

/*******************************************************************************
 * Controller
 *******************************************************************************/
/* @ngInject */ function Controller($injector) {
  var $svcs = { $ctrl: this, $globals: {} };

  $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs }));
  $injector.invoke(initGlobal, null, $svcs);
}

/*******************************************************************************
 * initCtrl */
/**
 * Initializes the Controller object.
 *******************************************************************************/
/* @ngInject */ function initCtrl($ctrl, $injector, $svcs, BusyScreen) {
  BusyScreen.setBusy(true);
  Object.assign($ctrl, {
    heading: 'OAuth',
    impersonate: false,
    showError: false,
    errorMessage: null,
    username: null,
    password: null,

    $onInit: $injector.invoke(onInit, null, $svcs)
  });
}

/*******************************************************************************
 * initGlobals */
/**
 * Initializes the Globals object.
 *******************************************************************************/
/* @ngInject */ function initGlobal($globals, $injector, $svcs) {
  Object.assign($globals, {
    currentUser: null,
    authenticate: $injector.invoke(authenticate, null, $svcs)
  });
}

/*******************************************************************************
 * Controller.onInit */
/**
 * Angular event that fires when the component is ready.
 *******************************************************************************/
/* @ngInject */ function onInit($ctrl, $globals, namedRouteService, Routes) {
  return function () {
    if (!$ctrl.state || !$ctrl.code) {
      namedRouteService.open(Routes.login);
    } else {
      $globals.authenticate();
    }
  };
}

/*******************************************************************************
 * Globals: authenticate */
/**
 * Completes the authentication process. If the server returns an orgList, the
 * user must select an org to continue. Otherwise, the user has been authenticated
 * and authorized, and can redirect to the entry path.
 *******************************************************************************/
/* @ngInject */ function authenticate(
  $ctrl,
  $q,
  BusyScreen,
  DisplayLicenseDialog,
  OrgSelectDialog,
  SystemLoginServices
) {
  /*------------------------------------------------------------*/
  /* If there was an error, set the message and show the error. */
  /*------------------------------------------------------------*/
  function handleError(error) {
    $ctrl.errorMessage = error.parsedResponse.message();
    $ctrl.showError = true;
  }

  /*---------------------------------------------------------------*/
  /* Sends the user to the main application through the entryPath. */
  /*---------------------------------------------------------------*/
  function redirect(entryPath) {
    window.location.href = entryPath;
  }

  return function () {
    SystemLoginServices.authenticateOAuth($ctrl.state, $ctrl.code)
      .then((data) => {
        /*------------------------------------------------*/
        /* Show the EULA if the user had not accepted it. */
        /*------------------------------------------------*/
        const showLicense =
          !data.hasLicense && !data.user.impersonate
            ? DisplayLicenseDialog.show()
            : $q.resolve();
        showLicense.then(function () {
          /*----------------------------------------------------------------*/
          /* If we found a user, but got back an orgList, display the list. */
          /*----------------------------------------------------------------*/
          if (data.orgList && data.orgList.length > 0) {
            OrgSelectDialog.show(data.orgList, (orgID) => {
              SystemLoginServices.authenticateUser(orgID).then((data) => {
                redirect(data.entryPath);
              });
            });
          } else {
            /*-----------------------------------------------*/
            /* Login successful. Navigate to the entry path. */
            /*-----------------------------------------------*/
            redirect(data.entryPath);
          }
        });
      })
      .catch(handleError)
      .finally(() => BusyScreen.setBusy(false));
  };
}
